export type Level = 'green' | 'yellow' | 'red'

export const LEVELS: Level[] = ['green', 'yellow', 'red']

export const LEVEL_COLORS: Record<Level, { bg: string; border: string; accent: string; onAccent: string; text: string }> = {
    green: { bg: '#e6f6ec', border: '#b9e6c9', accent: '#22b263', onAccent: '#ffffff', text: '#1f9d57' },
    yellow: { bg: '#fff6d6', border: '#f3e0a0', accent: '#f2c200', onAccent: '#5c4400', text: '#a87d00' },
    red: { bg: '#fde8e8', border: '#f5c2c2', accent: '#e04848', onAccent: '#ffffff', text: '#d63a3a' },
}

export const percentOf = (total: number, max: number) => (max ? Math.round((total * 100) / max) : 0)

export const levelOf = (pct: number): Level => (pct >= 75 ? 'green' : pct >= 50 ? 'yellow' : 'red')

// maxPoint = 0 - на неделе нечего было делать: такого ученика не красим и не считаем
export const studentLevel = (total: number, max: number): Level | null =>
    max ? levelOf(percentOf(total, max)) : null

export const levelStats = (students: { totalPoint: number; maxPoint: number }[]) => {
    const counts: Record<Level, number> = { green: 0, yellow: 0, red: 0 }
    let sum = 0
    let rated = 0
    let max = 0
    students.forEach((s) => {
        max = Math.max(max, s.maxPoint)
        const level = studentLevel(s.totalPoint, s.maxPoint)
        if (!level) return
        counts[level] += 1
        sum += s.totalPoint
        rated += 1
    })
    return { counts, rated, max, average: rated ? Math.round((sum / rated) * 10) / 10 : 0 }
}
